(() => {
  if (window.bsbPrice) return;

  const format = (cents) => {
    const amount = cents / 100;
    return '$' + amount.toLocaleString(undefined, {
      minimumFractionDigits: amount % 1 !== 0 ? 2 : 0,
      maximumFractionDigits: 2,
    });
  };

  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const render = (root, price, compareAtPrice) => {
    if (!root || !Number.isFinite(price)) return;
    let compare = Number.isFinite(compareAtPrice) ? compareAtPrice : 0;
    // TRADE PRICING (draft): only roots rendered by Liquid with data-trade="1" (B2B buyer).
    const trade = root.dataset.trade === '1' && window.bsbTrade && window.bsbTrade.pct ? window.bsbTrade : null;
    if (trade) compare = trade.compare(price, compare);
    const onSale = compare > price;
    const prefix = root.dataset.prefix || '';
    const saveLabel = trade ? '' : (root.dataset.saveLabel || '');
    const priceText = format(price);
    const spokenPrice = prefix ? `${prefix.toLowerCase()} ${priceText}` : priceText;
    const saveText = onSale && saveLabel ? saveLabel.replace('{amount}', format(compare - price)) : '';

    root.classList.toggle('bsb-price--sale', onSale);
    root.dataset.price = String(price);
    root.dataset.compareAtPrice = onSale ? String(compare) : '';

    let spoken = onSale ? `Was ${format(compare)}, now ${spokenPrice}` : spokenPrice;
    if (saveText) spoken += `. ${saveText}`;
    if (trade) spoken += `. ${trade.label}`;

    const current = make('span', 'bsb-price__current');
    if (prefix) current.append(make('span', 'bsb-price__prefix', prefix), ' ');
    current.append(priceText);

    const amounts = make('span', 'bsb-price__amounts');
    amounts.setAttribute('aria-hidden', 'true');
    amounts.append(current);
    if (onSale) amounts.append(make('s', 'bsb-price__compare', format(compare)));
    if (saveText) amounts.append(make('span', 'bsb-price__save', saveText));
    if (trade) amounts.append(make('span', 'bsb-price__trade', trade.label));

    root.replaceChildren(make('span', 'bsb-visually-hidden', spoken), amounts);
  };

  window.bsbPrice = { render, format };
})();
